export const mockIconURL = '/catalog/img/mockicon.svg';
